module.exports = __webpack_public_path__ + "static/p05_huevo01-20a55953055a0550f32055b0ef23c704.png";